import imageCompression from "browser-image-compression";
import React, { useEffect, useRef, useState } from "react";
// import "./CreatePost.scss";

export interface props {
  register?: any;
  label?: string;
  onImageChange?: (file: File | null) => void;
}

const AcedImageInput: React.FC<props> = ({ register, label, onImageChange }: props) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const previewBlobUrlRef = useRef<string | null>(null);

  useEffect(() => {
    return () => {
      if (previewBlobUrlRef.current) URL.revokeObjectURL(previewBlobUrlRef.current);
    };
  }, []);

  const setPreview = (url: string) => {
    if (previewBlobUrlRef.current) URL.revokeObjectURL(previewBlobUrlRef.current);
    previewBlobUrlRef.current = url;
    setImagePreview(url);
  };

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      setImagePreview(null);
      onImageChange?.(null);
      return;
    }

    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1080,
        useWebWorker: true,
      };
      const compressed = await imageCompression(file, options);
      setPreview(URL.createObjectURL(compressed));
      onImageChange?.(compressed);
    } catch (err) {
      console.error("Image compression failed:", err);
      setPreview(URL.createObjectURL(file));
      onImageChange?.(file);
    }
  };

  return (
    <div className="d-flex column center w-100">
      <div className="mb-3 w-100">
        {label && (
          <label htmlFor="imageUpload" className="form-label text-light">
            {label}
          </label>
        )}
        <input
          className="form-control"
          type="file"
          id="imageUpload"
          accept="image/*"
          {...register}
          onChange={handleImageChange}
        />
      </div>

      {imagePreview && (
        <img
          src={imagePreview}
          alt="Preview"
          style={{
            width: "120px",
            height: "120px",
            objectFit: "cover",
            borderRadius: "60px",
          }}
        />
      )}
    </div>
  );
};

export default AcedImageInput;
